import Vue from "vue";
import { user as userApi } from "../../../api/user.api";
import defaultUser from "@lab/meta/user";
import { DefaultUser, UserConfig } from "@lab/types/users";

const state = {
	config: {
		calloutrequests: false,
		meetingsenabled: false,
		sitetourrequests: false,
	},
	dashboards: [],
	errorMessage: null,
	isFetching: false,
	user: { ...defaultUser },
};

const getters = {
	config: (state) => state.config as UserConfig,
	error: (state): string => state.errorMessage as string,
	fetching: (state): boolean => state.isFetching as boolean,
	types: (_) => [],
	user: (state) => state.user as DefaultUser,
};

const actions = {
	async fetch({ commit, dispatch }, userid) {
		commit("LOAD_START");
		const _user = await userApi.fetch(userid);
		dispatch("prepare", _user);
		commit(`LOAD_FINISH`);
	},
	async create(_, user) {
		const _user = await userApi.create(user);
		return _user;
	},
	async activate({ commit, getters }) {
		await userApi.activate(getters.user.id);
		commit("updateField", { name: "status", value: "active" });
	},
	async deactivate({ commit, getters }) {
		await userApi.deactivate(getters.user.id);
		commit("updateField", { name: "status", value: "non-active" });
	},
	async promote({ getters }) {
		await userApi.promote(getters.user.id);
		//commit("updateField", { name: "status", value: "active" });
	},
	async demote({ getters }) {
		await userApi.demote(getters.user.id);
		//commit("updateField", { name: "status", value: "non-active" });
	},
	async invite({ commit, getters }) {
		await userApi.invite(getters.user.id);
		commit("updateField", { name: "status", value: "invited" });
	},
	async delete({ getters }) {
		await userApi.remove(getters.user.id);
	},
	async update({ getters }) {
		// update the user
		await userApi.update(getters.user);
	},
	prepare({ commit }, user) {
		commit("SET_USER", user);
	},
	set({ commit }, user) {
		commit("SET_USER", user);
	},
	reset({ commit }) {
		commit("RESET_USER");
	},
};

const mutations = {
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	},
	LOAD_FINISH(state: any) {
		state.errorMessage = null;
		state.isFetching = false;
	},
	SET_DASHBOARDS(state: any, dashboards) {
		state.dashboards = dashboards;
	},
	SET_CONFIG(state: any, config) {
		state.config = config;
	},
	SET_USER(state: any, user) {
		state.user = user;
	},
	RESET_USER(state: any) {
		state.user = { ...defaultUser };
	},
	addDashboards(state, dashboards) {
		dashboards.forEach((dashboard) => {
			state.dashboards.push(dashboard);
		});
	},
	removeDashboard(state, { id }) {
		const _dashboards = state.dashboards.filter(
			(dashboard) => dashboard.id !== id
		);
		state.dashboards = _dashboards;
	},
	sortDashboard(state, dashboards) {
		state.dashboards = dashboards;
	},
	updateField(state, { name, value }) {
		Vue.set(state.user, name, value);
	},
	updateConfig(state, { name, value }) {
		Vue.set(state.config, name, value);
	},
};

export default { namespaced: true, state, getters, actions, mutations };
